/**
 * Carbon structured list (DESIGN.md "Structured list"): rows split by
 * border-subtle, an optional 112px helper-text time column (72px and
 * wrapping on phones), primary text over a helper sub-line, and a trailing
 * tag. The Command Center's "Changes since last week" and the
 * notification lists use it.
 */
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import type { StructuredListProps } from './types'

export function StructuredList({ rows, timeColumn = 112, 'aria-label': ariaLabel, empty, className }: StructuredListProps) {
  if (rows.length === 0 && empty) {
    return <p className={clsx('m-0 border-t border-line-subtle py-6 text-helper text-text-helper', className)}>{empty}</p>
  }
  const withTime = timeColumn > 0
  return (
    <ul aria-label={ariaLabel} className={clsx('m-0 list-none p-0', className)}>
      {rows.map(row => (
        <li
          key={row.id}
          className={clsx(
            'grid gap-x-4 border-t border-line-subtle py-3.5 text-text-secondary',
            withTime
              ? 'grid-cols-[72px_minmax(0,1fr)_auto] c-md:grid-cols-[112px_minmax(0,1fr)_auto]'
              : 'grid-cols-[minmax(0,1fr)_auto]',
          )}
        >
          {withTime ? (
            <span className="pt-0.5 text-helper tabular-nums text-text-helper c-md:whitespace-nowrap">{row.time}</span>
          ) : null}
          <span className="min-w-0 text-text-primary">
            {row.href ? (
              <Link to={row.href} className="hover:underline">
                {row.title}
              </Link>
            ) : (
              row.title
            )}
            {row.sub ? <span className="mt-0.5 block text-helper text-text-helper">{row.sub}</span> : null}
          </span>
          <span className="flex items-start justify-end">{row.tag}</span>
        </li>
      ))}
    </ul>
  )
}

export default StructuredList
